import { createSelector, IGlobalState, TenantInfo } from '../../../../models/reduxState';
import { globalStateSelector } from '../../../app/selectors/contactUsSelector';

export const tenantInfoSelector = createSelector(
    globalStateSelector,
  (r: IGlobalState) => r.tenantInfo
);

export const hasUnifiedPremierContractSelector = createSelector(
    tenantInfoSelector,
  (r: TenantInfo) => !!r ? r.hasUnifiedContract: false
);

export const hasUnifiedEnterprisePremierContractSelector = createSelector(
  tenantInfoSelector,
  (r: TenantInfo) => !!r ? r.hasUnifiedEnterpriseContract: false
);

export const premierEntitlementIdSelector = createSelector(
  tenantInfoSelector,
  (r: TenantInfo) => !!r ? r.premierEntitlementId: ''
);

export const isPremierTenantEnabledSelector = createSelector(
  globalStateSelector,
  (r: IGlobalState) => r.isPremierTenantEnabled
);

export const isUnifiedPremierSelector = createSelector(
  [hasUnifiedPremierContractSelector, premierEntitlementIdSelector, isPremierTenantEnabledSelector],
  (hasUnifiedPremierContract: boolean, premierEntitlementId: string, isPremierTenantEnabled: boolean) =>
    !!hasUnifiedPremierContract && !!premierEntitlementId && !!isPremierTenantEnabled
);

export const isUnifiedEnterprisePremierSelector = createSelector(
  [hasUnifiedEnterprisePremierContractSelector, premierEntitlementIdSelector, isPremierTenantEnabledSelector],
  (hasUnifiedEnterprisePremierContract: boolean, premierEntitlementId: string, isPremierTenantEnabled: boolean) =>
    !!hasUnifiedEnterprisePremierContract && !!premierEntitlementId && !!isPremierTenantEnabled
);

export const isNonUnifiedPremierSelector = createSelector(
  [hasUnifiedPremierContractSelector, hasUnifiedEnterprisePremierContractSelector, premierEntitlementIdSelector, isPremierTenantEnabledSelector],
  (hasUnifiedPremierContract: boolean, hasUnifiedEnterprisePremierContract: boolean, premierEntitlementId: string, isPremierTenantEnabled: boolean) =>
    !hasUnifiedPremierContract && !hasUnifiedEnterprisePremierContract && !!premierEntitlementId && !!isPremierTenantEnabled
);

export const isPremierTenantSelector = createSelector(
  [premierEntitlementIdSelector],
  (premierEntitlementId: string) => !!premierEntitlementId
);

export const licensesSelector = createSelector(globalStateSelector, (g: IGlobalState) => g.licenses || []);
